import Vue from 'vue';

Vue.filter('join', (value: string[], separator?: string, capitalize?: boolean): string => {
    if (!value) {
        return '';
    }
    return value.map(v => (capitalize ? v.charAt(0).toUpperCase() + v.slice(1) : v)).join(separator);
});
